import React from 'react'
import { Button, Icon, Spin, Tag } from 'antd'

import './VisionDirectionCard.scss'

const VisionDirectionCard = ({
  creativeStatement,
  hasConversation,
  isStreaming,
  isSynthesizingVision,
  isLockingVision,
  isVisionLocked,
  isArchived,
  onSynthesizeVision,
  onLockVision
}) => {
  const hasStatement = Boolean(String(creativeStatement || '').trim())
  const shouldShowSynthesis = !isArchived && isSynthesizingVision

  if (!isArchived && (isStreaming || !hasConversation)) return null

  if (isArchived && !hasStatement) return null

  return (
    <section
      className={`creative-direction-chat__decision-panel${
        isArchived ? ' creative-direction-chat__decision-panel--archived' : ''
      }`}
    >
      <div className="creative-direction-chat__card-heading">
        <Icon type="star" />
        <div>
          <h3>Vision statement</h3>
          <p>
            {isArchived
              ? 'Locked and ready to guide the remaining creative guideline.'
              : 'Create and review the vision before moving to characters.'}
          </p>
        </div>
        {isVisionLocked ? <Tag color="green">Saved</Tag> : null}
      </div>

      {shouldShowSynthesis ? (
        <div className="creative-direction-chat__inline-loading">
          <Spin />
          <span>Synthesizing vision from the conversation...</span>
        </div>
      ) : (
        <>
          {hasStatement ? (
            <div className="creative-direction-chat__vision-statement">
              {creativeStatement}
            </div>
          ) : (
            <div className="creative-direction-chat__vision-empty">
              <Icon type="info-circle" />
              <span>
                When the conversation feels ready, create the vision statement.
              </span>
            </div>
          )}

          {!isArchived ? (
            <div className="creative-direction-chat__action-row">
              <Button
                icon={hasStatement ? 'reload' : 'star'}
                loading={isSynthesizingVision}
                disabled={
                  isStreaming ||
                  isVisionLocked ||
                  isLockingVision ||
                  !onSynthesizeVision
                }
                onClick={() => onSynthesizeVision({ showError: true })}
              >
                {hasStatement
                  ? 'Update vision statement'
                  : 'Create vision statement'}
              </Button>
              <Button
                type="primary"
                icon="check-circle"
                loading={isLockingVision}
                disabled={isStreaming || isVisionLocked || !hasStatement}
                onClick={onLockVision}
              >
                Lock vision
              </Button>
            </div>
          ) : null}
        </>
      )}
    </section>
  )
}

export default VisionDirectionCard
